import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.reduce.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-slate-200 flex-shrink-0"
};
const _hoisted_2 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_3 = {
  class: "flex-1 overflow-y-auto p-6"
};
const _hoisted_4 = {
  class: "bg-slate-50 rounded-xl p-4"
};
const _hoisted_5 = {
  class: "grid grid-cols-1 md:grid-cols-3 gap-4"
};
const _hoisted_6 = {
  class: "text-sm text-slate-900 font-mono break-all"
};
const _hoisted_7 = {
  class: "text-sm text-slate-900 font-mono break-all"
};
const _hoisted_8 = {
  class: "text-sm text-slate-900 font-mono break-all"
};
const _hoisted_9 = {
  class: "bg-slate-50 rounded-xl p-4"
};
const _hoisted_10 = {
  class: "relative"
};
const _hoisted_11 = {
  class: "grid grid-cols-1 md:grid-cols-2 gap-4"
};
const _hoisted_12 = {
  class: "bg-amber-50 rounded-xl p-4"
};
const _hoisted_13 = {
  class: "w-full"
};
const _hoisted_14 = {
  class: "flex flex-wrap items-center gap-3"
};
const _hoisted_15 = {
  key: 0,
  class: "text-sm text-slate-500"
};
const _hoisted_16 = {
  class: "flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50 rounded-b-2xl flex-shrink-0"
};
const _hoisted_17 = ["disabled"];
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = {
  key: 1
};
import { ref, reactive, watch, computed } from 'vue';
import { ElMessage } from 'element-plus';
import { createFranchiseeAccount, updateFranchiseeAccount, uploadLakalaFile } from '@/api/commission';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'FranchiseeAccountFormModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    franchiseeId: {
      type: [Number, String],
      default: null
    },
    accountData: {
      type: Object,
      default: null
    }
  },
  emits: ['update:visible', 'success'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const formRef = ref(null);
    const submitting = ref(false);
    const uploadingFile = ref(false);
    const fileInputRef = ref(null);
    const getInitialFormData = () => ({
      franchiseeId: null,
      tenantId: null,
      contactMobile: '',
      splitLowestRatio: null,
      splitEntrustFileName: '',
      splitEntrustFilePath: '',
      splitRange: 'MARK',
      sepFundSource: 'TR',
      eleContractNo: '',
      splitLaunchMode: 'MANUAL',
      settleType: '01',
      splitRuleSource: '',
      returnAcctModel: '',
      attachList: []
    });
    const formData = reactive(getInitialFormData());
    const isEdit = computed(() => !!props.accountData?.applyId);
    const requiresSplitRuleSource = computed(() => ['AUTO', 'POINTRULE'].includes(formData.splitLaunchMode));
    const merchantIdentifiers = computed(() => ({
      merchantNo: props.accountData?.merchantNo || '',
      merInnerNo: props.accountData?.merInnerNo || '',
      termNo: props.accountData?.termNo || ''
    }));
    const validateEntrustMaterial = (_rule, _value, callback) => {
      if (formData.eleContractNo || formData.splitEntrustFileName && formData.splitEntrustFilePath) {
        callback();
        return;
      }
      callback(new Error('请上传分账结算委托书或填写电子合同编号'));
    };
    const rules = computed(() => ({
      contactMobile: [{
        required: true,
        message: '请输入联系手机号',
        trigger: 'blur'
      }, {
        pattern: /^1[3-9]\d{9}$/,
        message: '请输入正确的手机号',
        trigger: 'blur'
      }],
      splitLowestRatio: [{
        required: true,
        message: '请输入最低分账比例',
        trigger: 'blur'
      }],
      splitRuleSource: [{
        required: requiresSplitRuleSource.value,
        message: '请选择分账规则来源',
        trigger: 'change'
      }],
      splitEntrustFileName: [{
        validator: validateEntrustMaterial,
        trigger: 'change'
      }]
    }));
    const resetForm = () => {
      const initial = getInitialFormData();
      Object.keys(initial).forEach(key => {
        formData[key] = props.accountData?.[key] ?? initial[key];
      });
      formData.franchiseeId = props.franchiseeId;
      formData.tenantId = props.accountData?.tenantId || props.franchiseeId;
      if (!Array.isArray(formData.attachList)) {
        formData.attachList = [];
      }
    };
    const resolveTargetTenantId = () => formData.tenantId || props.accountData?.tenantId || props.franchiseeId || formData.franchiseeId;
    const triggerFileInput = () => {
      fileInputRef.value?.click();
    };
    const handleFileChange = async event => {
      const file = event.target.files?.[0];
      if (!file) return;
      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
      if (!allowedTypes.includes(file.type)) {
        ElMessage.error('仅支持 PDF、JPG、PNG 格式');
        event.target.value = '';
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        ElMessage.error('文件大小不能超过 10MB');
        event.target.value = '';
        return;
      }
      const targetTenantId = resolveTargetTenantId();
      if (!targetTenantId) {
        ElMessage.error('请选择加盟商后再上传附件');
        event.target.value = '';
        return;
      }
      uploadingFile.value = true;
      try {
        const formDataUpload = new FormData();
        formDataUpload.append('tenantId', String(targetTenantId));
        formDataUpload.append('attType', 'SPLIT_ENTRUST_FILE');
        formDataUpload.append('file', file);
        formDataUpload.append('remark', '分账结算委托书');
        const res = await uploadLakalaFile(formDataUpload);
        formData.splitEntrustFileName = res.lakalaFileName || file.name;
        formData.splitEntrustFilePath = res.lakalaFilePath || '';
        formData.attachList = [{
          attachType: 'SPLIT_ENTRUST_FILE',
          attachName: res.lakalaFileName || file.name,
          attachStorePath: res.lakalaFilePath || ''
        }];
        await formRef.value?.validateField('splitEntrustFileName');
        ElMessage.success('文件上传成功');
      } catch (error) {
        console.error('文件上传失败:', error);
        ElMessage.error(error.message || '文件上传失败');
      } finally {
        uploadingFile.value = false;
        event.target.value = '';
      }
    };
    const handleClose = () => {
      resetForm();
      emit('update:visible', false);
    };
    const compactPayload = payload => {
      return Object.entries(payload).reduce((result, [key, value]) => {
        if (value === '' || value === null || value === undefined) {
          return result;
        }
        if (Array.isArray(value) && value.length === 0) {
          return result;
        }
        result[key] = value;
        return result;
      }, {});
    };
    const buildSubmitData = () => compactPayload({
      franchiseeId: props.franchiseeId,
      tenantId: resolveTargetTenantId(),
      contactMobile: formData.contactMobile,
      splitLowestRatio: formData.splitLowestRatio,
      splitEntrustFileName: formData.splitEntrustFileName,
      splitEntrustFilePath: formData.splitEntrustFilePath,
      splitRange: formData.splitRange,
      sepFundSource: formData.sepFundSource,
      eleContractNo: formData.eleContractNo,
      splitLaunchMode: formData.splitLaunchMode,
      settleType: formData.settleType,
      splitRuleSource: formData.splitRuleSource,
      returnAcctModel: formData.returnAcctModel,
      attachList: formData.attachList
    });
    const handleSubmit = async () => {
      try {
        await formRef.value.validate();
        submitting.value = true;
        const submitData = buildSubmitData();
        if (isEdit.value) {
          await updateFranchiseeAccount(submitData);
          ElMessage.success('更新成功');
        } else {
          await createFranchiseeAccount(submitData);
          ElMessage.success('申请已提交');
        }
        emit('success');
        handleClose();
      } catch (error) {
        console.error('保存分账业务失败:', error);
        if (error !== false) {
          ElMessage.error(error.message || '保存失败');
        }
      } finally {
        submitting.value = false;
      }
    };
    watch(() => props.visible, val => {
      if (val) {
        resetForm();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: __props.visible,
        size: "3xl",
        onClose: handleClose
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_2, _toDisplayString(isEdit.value ? '编辑分账业务' : '申请开通分账'), 1), _cache[9] || (_cache[9] = _createElementVNode("p", {
          class: "text-sm text-slate-500 mt-0.5"
        }, "商户信息来自已完成的拉卡拉进件或人工补录结果", -1))]), _createElementVNode("button", {
          onClick: handleClose,
          class: "p-1.5 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
        }, [...(_cache[10] || (_cache[10] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: formData,
          rules: rules.value,
          "label-width": "140px",
          class: "space-y-6"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_cache[14] || (_cache[14] = _createElementVNode("h4", {
            class: "text-sm font-medium text-slate-700 mb-4 flex items-center gap-2"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M3 7h18M3 12h18M3 17h18"
          })]), _createTextVNode(" 拉卡拉商户标识 ")], -1)), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, [_cache[11] || (_cache[11] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "银联商户号", -1)), _createElementVNode("div", _hoisted_6, _toDisplayString(merchantIdentifiers.value.merchantNo || '-'), 1)]), _createElementVNode("div", null, [_cache[12] || (_cache[12] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "内部商户号", -1)), _createElementVNode("div", _hoisted_7, _toDisplayString(merchantIdentifiers.value.merInnerNo || '-'), 1)]), _createElementVNode("div", null, [_cache[13] || (_cache[13] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "终端号", -1)), _createElementVNode("div", _hoisted_8, _toDisplayString(merchantIdentifiers.value.termNo || '-'), 1)])])]), _createElementVNode("div", _hoisted_9, [_cache[16] || (_cache[16] = _createElementVNode("h4", {
            class: "text-sm font-medium text-slate-700 mb-4 flex items-center gap-2"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          })]), _createTextVNode(" 分账开通信息 ")], -1)), _createVNode(_component_el_form_item, {
            label: "联系手机",
            prop: "contactMobile"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.contactMobile = $event),
              type: "text",
              placeholder: "请输入联系手机号",
              class: "form-input w-full"
            }, null, 512), [[_vModelText, formData.contactMobile, void 0, {
              trim: true
            }]])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "最低分账比例",
            prop: "splitLowestRatio"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.splitLowestRatio = $event),
              type: "number",
              step: "0.01",
              min: "0",
              max: "100",
              placeholder: "如70或70.50",
              class: "form-input w-full pr-8"
            }, null, 512), [[_vModelText, formData.splitLowestRatio, void 0, {
              number: true
            }]]), _cache[15] || (_cache[15] = _createElementVNode("span", {
              class: "absolute right-3 top-1/2 -translate-y-1/2 text-slate-400"
            }, "%", -1))])]),
            _: 1
          }), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_form_item, {
            label: "分账范围",
            prop: "splitRange"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formData.splitRange,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.splitRange = $event),
              class: "form-select w-full"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "标记交易分账",
                value: "MARK"
              }), _createVNode(_component_el_option, {
                label: "全部交易分账",
                value: "ALL"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "分账依据",
            prop: "sepFundSource"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formData.sepFundSource,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.sepFundSource = $event),
              class: "form-select w-full"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "交易分账",
                value: "TR"
              }), _createVNode(_component_el_option, {
                label: "余额分账",
                value: "BA"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "发起方式",
            prop: "splitLaunchMode"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formData.splitLaunchMode,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.splitLaunchMode = $event),
              class: "form-select w-full"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "手动分账",
                value: "MANUAL"
              }), _createVNode(_component_el_option, {
                label: "自动规则分账",
                value: "AUTO"
              }), _createVNode(_component_el_option, {
                label: "指定规则分账",
                value: "POINTRULE"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "提款类型",
            prop: "settleType"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formData.settleType,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => formData.settleType = $event),
              class: "form-select w-full"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "主动提款",
                value: "01"
              }), _createVNode(_component_el_option, {
                label: "交易自动结算",
                value: "03"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]), requiresSplitRuleSource.value ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "规则来源",
            prop: "splitRuleSource"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formData.splitRuleSource,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => formData.splitRuleSource = $event),
              class: "form-select w-full"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "请选择规则来源",
                value: ""
              }), _createVNode(_component_el_option, {
                label: "商户分账规则",
                value: "MER"
              }), _createVNode(_component_el_option, {
                label: "平台分账规则",
                value: "PLATFORM"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: "退货承担模式",
            prop: "returnAcctModel"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formData.returnAcctModel,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => formData.returnAcctModel = $event),
              class: "form-select w-full"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "默认",
                value: ""
              }), _createVNode(_component_el_option, {
                label: "收款账户",
                value: "01"
              }), _createVNode(_component_el_option, {
                label: "分账账户",
                value: "02"
              }), _createVNode(_component_el_option, {
                label: "收款账户 + 分账账户",
                value: "03"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]), _createElementVNode("div", _hoisted_12, [_cache[19] || (_cache[19] = _createElementVNode("h4", {
            class: "text-sm font-medium text-amber-800 mb-4 flex items-center gap-2"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414A1 1 0 0119 9.414V19a2 2 0 01-2 2z"
          })]), _createTextVNode(" 委托授权材料 ")], -1)), _createVNode(_component_el_form_item, {
            label: "电子合同编号",
            prop: "eleContractNo"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => formData.eleContractNo = $event),
              type: "text",
              placeholder: "已电子签约时填写合同编号，可不上传委托书",
              class: "form-input w-full"
            }, null, 512), [[_vModelText, formData.eleContractNo, void 0, {
              trim: true
            }]])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "上传委托书",
            prop: "splitEntrustFileName"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createElementVNode("input", {
              ref_key: "fileInputRef",
              ref: fileInputRef,
              type: "file",
              accept: ".pdf,.jpg,.jpeg,.png",
              class: "hidden",
              onChange: handleFileChange
            }, null, 544), _createElementVNode("div", _hoisted_14, [_createElementVNode("button", {
              type: "button",
              onClick: triggerFileInput,
              class: "px-4 py-2 border border-dashed border-amber-300 text-amber-700 rounded-lg hover:bg-amber-100 transition-colors flex items-center gap-2"
            }, [_cache[17] || (_cache[17] = _createElementVNode("svg", {
              class: "w-5 h-5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
            })], -1)), _createTextVNode(" " + _toDisplayString(uploadingFile.value ? '上传中...' : formData.splitEntrustFileName || '点击上传文件'), 1)]), formData.splitEntrustFileName ? (_openBlock(), _createElementBlock("span", _hoisted_15, " 已上传: " + _toDisplayString(formData.splitEntrustFileName), 1)) : _createCommentVNode("", true)]), _cache[18] || (_cache[18] = _createElementVNode("p", {
              class: "mt-2 text-xs text-slate-500"
            }, "未填写电子合同编号时，必须上传分账结算委托书；支持 PDF、JPG、PNG 格式。", -1))])]),
            _: 1
          })])]),
          _: 1
        }, 8, ["model", "rules"])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("button", {
          onClick: handleClose,
          class: "px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-100 transition-colors"
        }, " 取消 "), _createElementVNode("button", {
          onClick: handleSubmit,
          disabled: submitting.value,
          class: "btn-primary"
        }, [submitting.value ? (_openBlock(), _createElementBlock("span", _hoisted_18, "保存中...")) : (_openBlock(), _createElementBlock("span", _hoisted_19, "保存"))], 8, _hoisted_17)])]),
        _: 1
      }, 8, ["visible"])]);
    };
  }
};